var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongjinOH
 * @contact hjoh@detech.co.kr
 * @date 2023-07-03
 * @brief SEI  트리 컴포넌트
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from "react-router-dom";
//recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { SpgTreeState, alertState, curSchduleTreeState, mainState } from "../../../recoil/assessmentState";
import { reloadSpg, userInfoLoginState } from "../../../recoil/userState";
//util
import { langId } from "../../../recoil/langState";
import { loadingBoxState, treebarState } from "../../../recoil/menuState";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useTrans } from "../../../utils/langs/useTrans";
function TodaysInspectionTree(props) {
    const navigate = useNavigate();
    const t = useTrans();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curSchduleTreeState);
    const [recoilState, setRecoilState] = useRecoilState(mainState);
    const [alert, setAlert] = useRecoilState(alertState);
    const [toggle, setToggle] = useRecoilState(treebarState);
    const langIds = useRecoilValue(langId);
    // 캘린더 사이즈
    const myTextRef = useRef(null);
    const [treeWidth, setTreeWidth] = useState(0);
    const [treeDot, setTreeDot] = useState(false);
    //props
    const { setSpgInfo } = props;
    //
    const [treeItem, setTreeItem] = useState([]);
    const [treeText, setTreeText] = useState("");
    const [treeSearch, setTreeSearch] = useState("");
    const [text, setText] = useState("");
    const [treeSearchItem, setTreeSearchItem] = useState(null);
    const [treeCnt, setTreeCnt] = useState(null);
    const [treeTotal, setTreeTotal] = useState(null);
    // Mobile Check용
    const [isMobile, setMobile] = useState(false);
    useEffect(() => {
        // resize handler
        function handleResize() {
            // 모바일 체크
            if (window.innerWidth <= 390) {
                setMobile(true);
            }
            else {
                setMobile(false);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    });
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (window.innerWidth <= 390) {
            setMobile(true);
        }
    }), 100);
    useEffect(() => {
        // resize handler
        if (isMobile) {
            if (CUTIL.isnull(myTextRef))
                return;
            // 텍스트의 byte 수 계산
            // setByte(byteLength);
            const krlen = text.replace(/[a-z0-9]|[ \[\]{}()<>?|`~!@#$%^&*-_+=,.;:\"'\\]/g, "").replace(/(\s*)/g, "").length;
            const nonkrlen = text.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, "").replace(/(\s*)/g, "").length + (text.split(" ").length - 1);
            const maxLength = krlen * 2 + nonkrlen;
            const minLength = nonkrlen * 2 + krlen - 1;
            // 텍스트의 픽셀 값 계산
            let textWidth = myTextRef.current.offsetWidth;
            const computedStyle = window.getComputedStyle(myTextRef.current);
            const font = computedStyle.font;
            const texts = myTextRef.current.textContent;
            const canvas = document.createElement("canvas");
            const context = canvas.getContext("2d");
            context.font = font;
            const width = Math.floor(context.measureText(texts).width);
            const fonts = Math.round(nonkrlen / 2);
            truncateText(text, width);
            if (width > textWidth) {
                setTreeWidth(fonts);
                setTreeDot(true);
                return;
            }
            else {
                setTreeWidth(0);
                setTreeDot(false);
                return;
            }
        }
        else {
            setTreeWidth(0);
            setTreeDot(false);
            return;
        }
    }, [text, isMobile]);
    function truncateText(text, width) {
        let truncatedText = text;
        let byteLength = new TextEncoder().encode(text).length;
        while (width > 286 && truncatedText.length > 0) {
            truncatedText = truncatedText.substring(1);
            byteLength = new TextEncoder().encode(truncatedText).length;
            width = document.createElement("span").innerText = truncatedText;
            width = document.createElement("span").getBoundingClientRect().width;
        }
        if (truncatedText.length < text.length) {
            truncatedText = "..." + truncatedText;
        }
    }
    // Tree API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/usertree/dashboard`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: langIds.toString(),
    });
    let defTreeData = null;
    useEffect(() => {
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                let treeItem = data.body.filter((non, idx) => non.zone);
                let zoneCheck = treeItem.every((i) => i.zone.length == 0);
                if (!recoilTreeData.company.companyId && !zoneCheck) {
                    // 로딩시 recoli 저장
                    if (treeItem.length > 0 && !zoneCheck) {
                        let curComapy = treeItem.filter((item) => item.companyId == recoilState.companyId).length > 0
                            ? treeItem.filter((item) => item.companyId == recoilState.companyId)[0]
                            : treeItem[0];
                        let zoneItem = curComapy && curComapy.zone && curComapy.zone;
                        let curZone = zoneItem.filter((item) => item.zoneId == recoilState.zoneId).length > 0
                            ? zoneItem.filter((item) => item.zoneId == recoilState.zoneId)[0]
                            : zoneItem[0];
                        defTreeData = {
                            company: { companyId: curComapy.companyId, companyName: curComapy.companyName },
                            zone: { zoneId: curZone.zoneId, zoneName: curZone.zoneName, zoneBoolean: true },
                            subZone: { subZoneId: "", subZoneName: "", subZoneBoolean: false },
                            room: { roomId: "", roomName: "", roomBoolean: false },
                            spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false },
                        };
                        setText(defTreeData.company.companyName + " " + defTreeData.zone.zoneName);
                        setRecoilTreeData(defTreeData);
                        setRecoilState({
                            companyId: curComapy.companyId,
                            zoneId: curZone.zoneId,
                        });
                        if (recoilState.companyId &&
                            treeItem.filter((item) => item.companyId == recoilState.companyId).length <= 0) {
                            setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: t("라벨.해당회사사업장정보없음") }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                    }
                    else {
                        if (userInfo.role !== CONST.USERROLE_NONE) {
                            setAlert(Object.assign(Object.assign({}, alert), { layerId: "reset", type: CONST.TYPE_NONE, divTag: t("라벨.현재사업장이없어서운영관리화면으로이동합니다") }));
                            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                        }
                        else {
                            navigate(CONST.URL_NOT_FOUND);
                        }
                        setRecoilState({
                            companyId: "",
                            zoneId: "",
                        });
                    }
                }
                else {
                    setAlert(Object.assign(Object.assign({}, alert), { layerId: "reset", type: CONST.TYPE_NONE, divTag: t("라벨.현재사업장이없어서운영관리화면으로이동합니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                setTreeItem(data.body);
            }
            else {
                // data.body.map((err) => (err.msg));
            }
        }
    }, [data, langIds]);
    useEffect(() => {
        if (treeItem.filter((non) => non.zone).length > 0 && !treeItem.map((i) => i.zone.length).includes(0)) {
            defTreeData = {
                company: recoilTreeData.company,
                zone: recoilTreeData.zone,
                subZone: recoilTreeData.subZone,
                room: recoilTreeData.room,
                spg: recoilTreeData.spg,
            };
            let ids = defTreeData.zone.zoneId;
            if (defTreeData.subZone.subZoneId) {
                ids = defTreeData.subZone.subZoneId;
            }
            else if (!defTreeData.subZone.subZoneBoolean && defTreeData.room.roomId) {
                ids = defTreeData.room.roomId;
            }
            else if (!defTreeData.room.roomBoolean && defTreeData.spg.companySpgId > 0) {
                ids = `${defTreeData.room.roomId}:${defTreeData.spg.companySpgId}`;
            }
            const atag = document.getElementById(ids);
            // const offset = atag.offsetTop;
            if (treeItem.length > 0) {
                atag.scrollIntoView({
                    block: "center",
                });
                window.scrollTo({ top: 0 });
            }
            setText(defTreeData.company.companyName + " " + defTreeData.zone.zoneName);
            setRecoilTreeData(defTreeData);
        }
    }, [treeItem]);
    // 트리메뉴 접고 펼쳐지는 버튼 액션
    function treeMenuOnClickSelf(e) {
        e.preventDefault();
        let tree_class = document.querySelector(".treebar");
        let section_class = document.querySelector(".content");
        if (!tree_class.classList.contains("close")) {
            tree_class.classList.add("close");
            section_class.setAttribute("style", "width: calc(100% - 40px)");
        }
        else {
            tree_class.classList.remove("close");
            section_class.setAttribute("style", "");
        }
    }
    function treeSearchIcon(text) {
        if (text == "null") {
            setTreeSearch("");
            setTreeText("");
            setTreeSearchItem(null);
            setTreeCnt(null);
            setTreeTotal(null);
        }
        else if (text.length > 0) {
            setTreeSearch(text);
            let listItem = [];
            treeItem
                .filter((check) => check.zone.length != 0)
                .forEach((company) => {
                // 회사 정보 저장
                listItem.push({ id: company.companyId, name: company.companyName });
                // 사업장 배열
                const zoneList = company.hasOwnProperty("zone") ? company.zone : null;
                // 사업장 정보 저장
                zoneList &&
                    zoneList.map((zone) => {
                        listItem.push({ id: zone.zoneId, name: zone.zoneName });
                        // 상세 사업장 배열
                        const subZoneList = zone.hasOwnProperty("subZone") ? zone.subZone : null;
                        // 상세 사업장 정보
                        subZoneList &&
                            subZoneList.map((subZone) => {
                                listItem.push({ id: subZone.subZoneId, name: subZone.subZoneName });
                                //전기실 배열
                                const roomList = subZone.hasOwnProperty("room") ? subZone.room : null;
                                //전기실 정보
                                roomList &&
                                    roomList.map((room) => {
                                        listItem.push({ id: room.roomId, name: room.roomName });
                                        //전기실 배열
                                        const spgList = room.hasOwnProperty("spg") ? room.spg : null;
                                        //전기실 정보
                                        spgList &&
                                            spgList
                                                .filter((item) => item.isonSpg)
                                                .map((spg) => {
                                                listItem.push({ id: room.roomId + ":" + spg.companySpgId, name: spg.spgName });
                                            });
                                    });
                            });
                    });
            });
            const search = listItem.filter((search) => search.name.toUpperCase().includes(text.toUpperCase()));
            const searchCount = [];
            for (let i = 0; i < search.length; i++) {
                searchCount.push({
                    id: search[i].id,
                    name: search[i].name,
                    cnt: i,
                });
            }
            setTreeSearchItem(searchCount);
            setTreeCnt(searchCount[0]);
            setTreeTotal(searchCount.length);
            const scrollsId = document.getElementById("scrolls");
            const spgId = scrollsId.querySelector(`a[id="${searchCount[0].id}"]`); // scrolls ID 에서 a tag id 상단
            spgId.scrollIntoView({ block: "center" }); // 검색된 tree의 id ‰
            window.scrollTo({ top: 0 });
        }
        else {
            //
        }
    }
    //엔터검색
    function SearchTree(e) {
        if (e.key == "Enter") {
            treeSearchIcon(e.target.value);
        }
    }
    //검색 초기화
    function SearchReset(e) {
        if (e.key == "Enter") {
            TreeDown(e);
        }
        else {
            treeSearchIcon("null");
        }
    }
    useEffect(() => {
        if (!treeSearch) {
            const focus = document.getElementById("resetInput");
            focus.focus();
        }
        else {
            const focus = document.getElementById("setInput");
            focus.focus();
        }
    }, [treeSearch]);
    // 위로 이동
    function TreeUp(e) {
        // const spgId = document.getElementById(treeSearchItem[treeCnt.cnt].id);
        const scrollsId = document.getElementById("scrolls");
        if (treeCnt.cnt <= 0) {
            const spgId = scrollsId.querySelector(`a[id="${treeSearchItem[treeSearchItem.length - 1].id}"]`); // scrolls ID 에서 a tag id 마지막 Id 찾기
            setTreeCnt(treeSearchItem[treeSearchItem.length - 1]);
            // scrollsId.scrollTo({ top: scrollsId.scrollHeight, }) // 스크롤 영역의 id 최하단 이동
            spgId.scrollIntoView({ block: "center" }); // 검색된 tree의 id
        }
        else {
            const spgId = scrollsId.querySelector(`a[id="${treeSearchItem[treeCnt.cnt - 1].id}"]`); // scrolls ID 에서 a tag id 상단
            setTreeCnt(treeSearchItem[treeCnt.cnt - 1]);
            spgId.scrollIntoView({ block: "center" }); // 검색된 tree의 id
        }
        window.scrollTo({ top: 0 });
        return;
    }
    // 아래 이동
    function TreeDown(e) {
        // const spgId = document.getElementById(treeSearchItem[treeCnt.cnt].id);
        const scrollsId = document.getElementById("scrolls");
        if (treeTotal - 1 > treeCnt.cnt) {
            const spgId = scrollsId.querySelector(`a[id="${treeSearchItem[treeCnt.cnt + 1].id}"]`); // scrolls ID 에서 a tag id 상단
            setTreeCnt(treeSearchItem[treeCnt.cnt + 1]);
            spgId.scrollIntoView({ block: "center" }); // 검색된 tree의 id
        }
        else {
            const spgId = scrollsId.querySelector(`a[id="${treeSearchItem[0].id}"]`); // scrolls ID 에서 a tag id 상단
            setTreeCnt(treeSearchItem[0]);
            spgId.scrollIntoView({ block: "center" }); // scrolls ID 에서 a tag id 최상단 Id 찾기
        }
        window.scrollTo({ top: 0 });
        return;
    }
    function MobileClick(e) {
        if (toggle == false) {
            setToggle(true);
        }
        else {
            setToggle(false);
        }
    }
    function CompanyClick(item) {
        setRecoilTreeData({
            company: { companyId: item.companyId, companyName: item.companyName },
            zone: { zoneId: item.zone[0].zoneId, zoneName: item.zone[0].zoneName, zoneBoolean: true },
            subZone: { subZoneId: "", subZoneName: "", subZoneBoolean: false },
            room: { roomId: "", roomName: "", roomBoolean: false },
            spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false },
        });
        setRecoilState({
            companyId: item.companyId,
            zoneId: item.zone[0].zoneId,
        });
        setText(item.companyName + " " + item.zone[0].zoneName);
        setToggle(false);
        treeSearchIcon("null");
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: `treebar__toggleBtn ${toggle ? "active" : ""}`, onClick: (e) => MobileClick(e) }, { children: _jsx("p", Object.assign({ ref: myTextRef }, { children: treeDot ? "..." + text.substring(treeWidth, text.length) : text })) })), _jsxs("div", Object.assign({ className: `box treebar  ${toggle ? "active" : ""}` }, { children: [_jsxs("div", Object.assign({ className: "box__header", onClick: (e) => treeMenuOnClickSelf(e) }, { children: [_jsx("p", Object.assign({ className: "box__title" }, { children: recoilTreeData.company.companyName })), _jsx("div", Object.assign({ className: "box__etc" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-tree" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD2B8\uB9AC\uBA54\uB274\uC811\uAE30\uD3BC\uCE58\uAE30" })) })) }))] })), !treeSearch ? (_jsxs("div", Object.assign({ className: "box__search" }, { children: [_jsx("input", { id: "resetInput", type: "text", placeholder: "Search\u2026", value: treeText, onKeyDown: (e) => SearchTree(e), onChange: (e) => setTreeText(e.target.value) }), _jsx("button", Object.assign({ type: "button", className: "btn btn-search", onClick: (e) => treeSearchIcon(treeText) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] }))) : (_jsxs("div", Object.assign({ className: "box__search focus" }, { children: [_jsxs("div", Object.assign({ className: "focus__search" }, { children: [_jsx("input", { type: "text", placeholder: "Search\u2026", id: "setInput", value: treeText, onChange: (e) => setTreeText(e.target.value), onKeyDown: (e) => SearchReset(e) }), _jsxs("span", { children: [treeCnt ? treeCnt.cnt + 1 : 0, " / ", treeTotal && treeTotal] })] })), _jsxs("div", Object.assign({ className: "focus__btn" }, { children: [_jsx("button", Object.assign({ type: "button", className: "arrow-up", onClick: (e) => TreeUp(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC704\uCABD\uC73C\uB85C" })) })), _jsx("button", Object.assign({ type: "button", className: "arrow-down", onClick: (e) => TreeDown(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC544\uB798\uCABD\uC73C\uB85C" })) })), _jsx("button", Object.assign({ type: "button", className: "close", onClick: (e) => treeSearchIcon("null") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uBC84\uD2BC\uB2EB\uAE30" })) }))] }))] }))), _jsx("div", Object.assign({ className: "treearea", id: "scrolls" }, { children: recoilTreeData &&
                            treeItem
                                .filter((chek) => chek.zone.length != 0)
                                .map((item, idx) => (_jsxs(React.Fragment, { children: [_jsx("div", Object.assign({ className: `tree__title 
                            ${treeCnt && item.companyId == treeCnt.id
                                            ? "highlight"
                                            : treeSearch && item.companyName.toUpperCase().includes(treeSearch.toUpperCase())
                                                ? "on"
                                                : ""} `, onClick: (e) => CompanyClick(item) }, { children: _jsx("a", Object.assign({ href: "#", id: item.companyId, onClick: (e) => e.preventDefault(), className: treeCnt && item.companyId == treeCnt.id
                                                ? "highlight"
                                                : treeSearch && item.companyName.toUpperCase().includes(treeSearch.toUpperCase())
                                                    ? "on"
                                                    : "" }, { children: item.companyName })) })), _jsx("ul", Object.assign({ id: "tree", className: "tree" }, { children: _jsx(ZoneTree, { zoneItem: item.zone, company: item, treeSearch: treeSearch, treeSearchItem: treeSearchItem, treeCnt: treeCnt, setText: setText, setToggle: setToggle, setSpgInfo: setSpgInfo, treeSearchIcon: treeSearchIcon }) }))] }, "compay_" + idx.toString()))) }))] }))] }));
}
export default TodaysInspectionTree;
function ZoneTree(props) {
    //recoil
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curSchduleTreeState);
    const setRecoilState = useSetRecoilState(mainState);
    //props
    const { zoneItem, company, treeSearch, treeSearchItem, treeCnt, setText, setToggle, setSpgInfo, treeSearchIcon } = props;
    function ZoneClick(item) {
        setRecoilTreeData({
            company: { companyId: company.companyId, companyName: company.companyName },
            zone: { zoneId: item.zoneId, zoneName: item.zoneName, zoneBoolean: true },
            subZone: { subZoneId: "", subZoneName: "", subZoneBoolean: false },
            room: { roomId: "", roomName: "", roomBoolean: false },
            spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false },
        });
        setRecoilState({
            companyId: company.companyId,
            zoneId: item.zoneId,
        });
        setText(company.companyName + " " + item.zoneName);
        setToggle(false);
        treeSearchIcon("null");
    }
    return (_jsx(_Fragment, { children: recoilTreeData &&
            zoneItem.map((item, idx) => (_jsxs("li", Object.assign({ className: "tree__depth1" }, { children: [_jsx("input", { type: "checkbox", id: `root1_${item.zoneId}` }), _jsxs("a", Object.assign({ id: item.zoneId, style: { cursor: "pointer" }, className: `${treeCnt && item.zoneId == treeCnt.id
                            ? "highlight"
                            : treeSearch && item.zoneName.toUpperCase().includes(treeSearch.toUpperCase())
                                ? "on"
                                : !treeSearch && recoilTreeData.zone.zoneBoolean && recoilTreeData.zone.zoneId === item.zoneId
                                    ? "on"
                                    : ""}` }, { children: [_jsx("label", { htmlFor: `root1_${item.zoneId}` }), _jsxs("span", Object.assign({ className: `${treeCnt && item.subZoneId == treeCnt.id
                                    ? "highlight"
                                    : treeSearch && item.zoneName.toUpperCase().includes(treeSearch.toUpperCase())
                                        ? "on"
                                        : !treeSearch && recoilTreeData.zone.zoneBoolean && recoilTreeData.zone.zoneId === item.zoneId
                                            ? "on"
                                            : ""}`, onClick: (e) => ZoneClick(item) }, { children: [" ", item.zoneName] }))] })), _jsx("ul", Object.assign({ className: "tree__depth2" }, { children: _jsx(SubZoneTree, { subZoneItem: item.subZone, company: company, zone: item, treeSearch: treeSearch, treeSearchItem: treeSearchItem, treeCnt: treeCnt, setText: setText, setToggle: setToggle, setSpgInfo: setSpgInfo, treeSearchIcon: treeSearchIcon }) }))] }), "zone_" + idx.toString()))) }));
}
function SubZoneTree(props) {
    //recoil
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curSchduleTreeState);
    const setRecoilState = useSetRecoilState(mainState);
    //props
    const { subZoneItem, company, zone, treeSearch, treeSearchItem, treeCnt, setText, setToggle, setSpgInfo, treeSearchIcon, } = props;
    function SubZoneClick(item) {
        setRecoilTreeData({
            company: { companyId: company.companyId, companyName: company.companyName },
            zone: { zoneId: zone.zoneId, zoneName: zone.zoneName, zoneBoolean: false },
            subZone: { subZoneId: item.subZoneId, subZoneName: item.subZoneName, subZoneBoolean: true },
            room: { roomId: "", roomName: "", roomBoolean: false },
            spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false },
        });
        setRecoilState({
            companyId: company.companyId,
            zoneId: zone.zoneId,
        });
        setText(company.companyName + " " + zone.zoneName + " " + item.subZoneName);
        setToggle(false);
        treeSearchIcon("null");
    }
    return (_jsx(_Fragment, { children: subZoneItem &&
            subZoneItem.map((item, idx) => (_jsxs("li", { children: [_jsx("input", { type: "checkbox", id: `node_1${item.subZoneId}` }), _jsxs("a", Object.assign({ id: item.subZoneId, style: { cursor: "pointer" }, className: `${treeCnt && item.subZoneId == treeCnt.id
                            ? "highlight"
                            : treeSearch && item.subZoneName.toUpperCase().includes(treeSearch.toUpperCase())
                                ? "on"
                                : !treeSearch &&
                                    recoilTreeData.subZone.subZoneBoolean &&
                                    recoilTreeData.subZone.subZoneId === item.subZoneId
                                    ? "on"
                                    : ""}` }, { children: [_jsx("label", { htmlFor: `node_1${item.subZoneId}` }), _jsxs("span", Object.assign({ className: `${treeCnt && item.subZoneId == treeCnt.id
                                    ? "highlight"
                                    : treeSearch && item.subZoneName.toUpperCase().includes(treeSearch.toUpperCase())
                                        ? "on"
                                        : !treeSearch &&
                                            recoilTreeData.subZone.subZoneBoolean &&
                                            recoilTreeData.subZone.subZoneId === item.subZoneId
                                            ? "on"
                                            : ""}`, onClick: (e) => SubZoneClick(item) }, { children: [" ", item.subZoneName] }))] })), _jsx("ul", Object.assign({ className: "tree__depth3" }, { children: _jsx(RoomTree, { roomItem: item.room, company: company, zone: zone, subZone: item, treeSearch: treeSearch, treeSearchItem: treeSearchItem, treeCnt: treeCnt, setText: setText, setToggle: setToggle, setSpgInfo: setSpgInfo, treeSearchIcon: treeSearchIcon }) }))] }, "subZone_" + idx.toString()))) }));
}
function RoomTree(props) {
    // recoil
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curSchduleTreeState);
    const setReloadSpg = useSetRecoilState(reloadSpg);
    const setRecoilState = useSetRecoilState(mainState);
    //props
    const { roomItem, company, zone, subZone, treeSearch, treeSearchItem, treeCnt, setText, setToggle, setSpgInfo, treeSearchIcon, } = props;
    //room 클릭
    function RoomClick(item) {
        setRecoilTreeData({
            company: { companyId: company.companyId, companyName: company.companyName },
            zone: { zoneId: zone.zoneId, zoneName: zone.zoneName, zoneBoolean: false },
            subZone: { subZoneId: subZone.subZoneId, subZoneName: subZone.subZoneName, subZoneBoolean: false },
            room: { roomId: item.roomId, roomName: item.roomName, roomBoolean: true },
            spg: { companySpgId: -1, spgId: -1, spgName: "", spgBoolean: false },
        });
        setRecoilState({
            companyId: company.companyId,
            zoneId: zone.zoneId,
        });
        setText(company.companyName + " " + zone.zoneName + " " + subZone.subZoneName + " " + item.roomName);
        treeSearchIcon("null");
        setToggle(false);
        setReloadSpg(true);
    }
    const [spgTreeOpen, setSpgTreeOpen] = useState(true);
    useEffect(() => {
        if (treeSearch && treeSearchItem && treeSearchItem.length > 0) {
            setSpgTreeOpen(false);
        }
    }, [treeSearch]);
    useEffect(() => {
        if (!spgTreeOpen && treeSearchItem && treeSearchItem.length > 0) {
            const scrollsId = document.getElementById("scrolls");
            const spgId = scrollsId.querySelector(`a[id="${treeSearchItem[0].id}"]`);
            spgId.scrollIntoView({ block: "center" });
        }
    }, [spgTreeOpen]);
    return (_jsx(_Fragment, { children: roomItem &&
            roomItem.map((item, idx) => (_jsxs("li", { children: [_jsx("input", { type: "checkbox", id: `node11_${item.roomId}`, checked: spgTreeOpen, onChange: () => setSpgTreeOpen(!spgTreeOpen) }), _jsxs("a", Object.assign({ id: item.roomId, style: { cursor: "pointer" }, className: `${treeCnt && item.roomId == treeCnt.id
                            ? "highlight"
                            : treeSearch && item.roomName.toUpperCase().includes(treeSearch.toUpperCase())
                                ? "on"
                                : !treeSearch && recoilTreeData.room.roomBoolean && recoilTreeData.room.roomId === item.roomId
                                    ? "on"
                                    : ""}` }, { children: [_jsx("label", { htmlFor: `node11_${item.roomId}` }), _jsx("span", Object.assign({ className: `${treeCnt && item.roomId == treeCnt.id
                                    ? "highlight"
                                    : treeSearch && item.roomName.toUpperCase().includes(treeSearch.toUpperCase())
                                        ? "on"
                                        : !treeSearch && recoilTreeData.room.roomBoolean && recoilTreeData.room.roomId === item.roomId
                                            ? "on"
                                            : ""}`, onClick: (e) => RoomClick(item) }, { children: item.roomName }))] })), _jsx("ul", Object.assign({ className: "tree__depth4" }, { children: _jsx(SpgTree, { spgItem: item.spg, company: company, zone: zone, subZone: subZone, room: item, treeSearch: treeSearch, treeSearchItem: treeSearchItem, treeCnt: treeCnt, setText: setText, setToggle: setToggle, treeSearchIcon: treeSearchIcon }) }))] }, "room_" + idx.toString()))) }));
}
function SpgTree(props) {
    //recoil
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [recoilTreeData, setRecoilTreeData] = useRecoilState(curSchduleTreeState);
    const setReloadSpg = useSetRecoilState(reloadSpg);
    const [recoilSpgData, setRecoilSpgData] = useRecoilState(SpgTreeState);
    const setRecoilState = useSetRecoilState(mainState);
    //props
    const { spgItem, company, zone, subZone, room, treeSearch, setText, treeCnt, setToggle, treeSearchIcon } = props;
    //spg 클릭
    function Spglick(item) {
        setRecoilTreeData({
            company: { companyId: company.companyId, companyName: company.companyName },
            zone: { zoneId: zone.zoneId, zoneName: zone.zoneName, zoneBoolean: false },
            subZone: { subZoneId: subZone.subZoneId, subZoneName: subZone.subZoneName, subZoneBoolean: false },
            room: { roomId: room.roomId, roomName: room.roomName, roomBoolean: false },
            spg: { companySpgId: item.companySpgId, spgId: item.spgId, spgName: item.spgName, spgBoolean: true },
        });
        setRecoilState({
            companyId: company.companyId,
            zoneId: zone.zoneId,
        });
        setRecoilSpgData({
            spg: { companySpgId: -1, spgId: -1, spgName: "" },
        });
        setText(company.companyName + " " + zone.zoneName + " " + subZone.subZoneName + " " + room.roomName + " " + item.spgName);
        treeSearchIcon("null");
        setToggle(false);
        setReloadSpg(true);
    }
    return (_jsx(_Fragment, { children: recoilTreeData &&
            spgItem
                .filter((item) => item.isonSpg)
                .map((item, idx) => (_jsxs("li", { children: [_jsx("input", { type: "checkbox", id: `node111_${room.roomId + ":" + item.companySpgId}` }), _jsxs("a", Object.assign({ id: room.roomId + ":" + item.companySpgId, style: { cursor: "pointer" }, className: `${treeCnt && room.roomId + ":" + item.companySpgId == treeCnt.id
                            ? "highlight"
                            : treeSearch && item.spgName.toUpperCase().includes(treeSearch.toUpperCase())
                                ? "on"
                                : !treeSearch &&
                                    recoilTreeData.spg.spgBoolean &&
                                    recoilTreeData.room.roomId === room.roomId &&
                                    recoilTreeData.spg.companySpgId === item.companySpgId
                                    ? "on"
                                    : ""}` }, { children: [_jsx("label", { htmlFor: `node111_${room.roomId + ":" + item.companySpgId}`, className: "lastTree" }), _jsxs("span", Object.assign({ className: `${treeCnt && room.roomId + ":" + item.companySpgId == treeCnt.id
                                    ? "highlight"
                                    : treeSearch && item.spgName.toUpperCase().includes(treeSearch.toUpperCase())
                                        ? "on"
                                        : !treeSearch &&
                                            recoilTreeData.spg.spgBoolean &&
                                            recoilTreeData.room.roomId === room.roomId &&
                                            recoilTreeData.spg.companySpgId === item.companySpgId
                                            ? "on"
                                            : ""}`, onClick: (e) => Spglick(item) }, { children: [" ", item.spgName] }))] }))] }, "spg_" + idx.toString()))) }));
}
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
